import React from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import ProfileUserImage from "../../../../components/shared/userImg/ProfileUserImage";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {
  userData?: any;
}

const ProfileUserInfo = ({ userData, ...props }: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------
  // Access to i18n instance that you may use to translate your content.
  const { t } = useTranslation();

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <>
      <ProfileUserImage/>

      <div className="name">
        {userData?.firstname} {userData?.lastname}
      </div>
      <div className="company">
        {userData?.company?.user_role} @ {userData?.company?.name}
      </div>
      <div className="member-since">
        {t("pages.profile.member_since", {
          date: moment.unix(userData?.member_since.seconds).format("MMMM, YYYY"),
        })}
      </div>
    </>
  );
};
export default ProfileUserInfo;
